var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1032,
    height: 245,
    viewBox: "0 0 1032 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2832_25885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0H1012C1023.05 0 1032 8.9543 1032 20V279H0V20Z",
    fill: "#2B67AF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 887.5,
    cy: 114.5,
    r: 66.5,
    fill: "#218AF1",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 937,
    cy: 56,
    r: 72,
    fill: "#218AF1",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 945,
    cy: 47.5,
    rx: 60,
    ry: 60.5,
    fill: "#218AF1",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.15 86C1113.15 130.735 1076.66 167 1031.65 167C986.641 167 950.152 130.735 950.152 86C950.152 41.2649 982.988 13 1028 13C1066.5 54 1113.15 41.2649 1113.15 86Z",
    fill: "#218AF1",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 966,
    cy: 187.5,
    rx: 81,
    ry: 81.5,
    fill: "#218AF1",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.094,
    cy: 116.438,
    r: 66.5,
    transform: "rotate(92.1799 369.094 116.438)",
    fill: "#218AF1",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.669,
    cy: 168.127,
    r: 72,
    transform: "rotate(92.1799 425.669 168.127)",
    fill: "#218AF1",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 433.858,
    cy: 176.445,
    rx: 60,
    ry: 60.5,
    transform: "rotate(92.1799 433.858 176.445)",
    fill: "#218AF1",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.99 343.011C344.288 341.309 309.437 303.468 311.149 258.489C312.861 213.51 350.488 178.427 395.191 180.129C439.893 181.831 466.889 215.718 465.177 260.697C422.742 297.609 433.693 344.713 388.99 343.011Z",
    fill: "#218AF1",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.161,
    cy: 192.104,
    rx: 81,
    ry: 81.5,
    transform: "rotate(92.1799 293.161 192.104)",
    fill: "#218AF1",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6285 273.722C-11.9141 284.46 -22.7023 258.14 -27.367 227.055C-32.0317 195.969 -34.3046 135.25 -4.76199 124.512C24.7806 113.774 109.773 144.429 114.438 175.514",
    stroke: "url(#paint0_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2861 270.591C-9.91369 280.841 -20.2115 255.718 -24.6641 226.045C-29.1168 196.373 -31.2864 138.413 -3.08664 128.164C25.1131 117.914 106.242 147.175 110.695 176.847",
    stroke: "url(#paint1_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9437 267.461C-7.91326 277.222 -17.7207 253.296 -21.9613 225.036C-26.2019 196.777 -28.2682 141.577 -1.41129 131.816C25.4456 122.054 102.711 149.922 106.952 178.181",
    stroke: "url(#paint2_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6013 264.331C-5.91281 273.604 -15.2298 250.873 -19.2584 224.027C-23.287 197.18 -25.25 144.741 0.264061 135.467C25.7781 126.194 99.1806 152.668 103.209 179.515",
    stroke: "url(#paint3_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2589 261.2C-3.91236 269.985 -12.739 248.451 -16.5556 223.017C-20.3721 197.584 -22.2318 147.904 1.93941 139.119C26.1106 130.334 95.6498 155.414 99.4663 180.848",
    stroke: "url(#paint4_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9165 258.069C-1.9119 266.367 -10.2482 246.029 -13.8527 222.008C-17.4573 197.988 -19.2136 151.068 3.61476 142.771C26.4432 134.474 92.119 158.161 95.7236 182.181",
    stroke: "url(#paint5_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5751 254.939C0.089519 262.748 -7.75641 243.606 -11.1489 220.999C-14.5414 198.391 -16.1945 154.232 5.29109 146.422C26.7766 138.613 88.5892 160.907 91.9817 183.515",
    stroke: "url(#paint6_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2327 251.808C2.08997 259.129 -5.26559 241.184 -8.44606 219.99C-11.6265 198.795 -13.1763 157.395 6.96644 150.074C27.1091 142.753 85.0584 163.654 88.2389 184.848",
    stroke: "url(#paint7_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8903 248.678C4.09042 255.511 -2.77478 238.762 -5.74321 218.98C-8.71164 199.199 -10.1581 160.559 8.64179 153.726C27.4416 146.893 81.5276 166.4 84.4961 186.182",
    stroke: "url(#paint8_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5479 245.547C6.09087 251.892 -0.283955 236.34 -3.04036 217.971C-5.79676 199.602 -7.13987 163.723 10.3171 157.378C27.7741 151.033 77.9969 169.147 80.7533 187.515",
    stroke: "url(#paint9_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2055 242.417C8.09132 248.273 2.20686 233.917 -0.337509 216.962C-2.88188 200.006 -4.12167 166.886 11.9925 161.029C28.1066 155.172 74.4661 171.893 77.0104 188.849",
    stroke: "url(#paint10_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8631 239.286C10.0918 244.655 4.69768 231.495 2.36534 215.952C0.0329976 200.41 -1.10348 170.05 13.6678 164.681C28.4391 159.312 70.9353 174.639 73.2676 190.182",
    stroke: "url(#paint11_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5207 236.156C12.0922 241.036 7.1885 229.073 5.06819 214.943C2.94788 200.813 1.91472 173.214 15.3432 168.333C28.7716 163.452 67.4045 177.386 69.5248 191.516",
    stroke: "url(#paint12_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1783 233.025C14.0927 237.418 9.67932 226.651 7.77104 213.934C5.86276 201.217 4.93292 176.377 17.0185 171.985C29.1042 167.592 63.8737 180.132 65.782 192.849",
    stroke: "url(#paint13_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8359 229.894C16.0931 233.799 12.1701 224.228 10.4739 212.924C8.77764 201.621 7.95111 179.541 18.6939 175.636C29.4367 171.732 60.3429 182.879 62.0392 194.182",
    stroke: "url(#paint14_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4935 226.764C18.0935 230.18 14.661 221.806 13.1767 211.915C11.6925 202.024 10.9693 182.704 20.3692 179.288C29.7692 175.871 56.8122 185.625 58.2964 195.516",
    stroke: "url(#paint15_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1511 223.633C20.094 226.562 17.1518 219.384 15.8796 210.906C14.6074 202.428 13.9875 185.868 22.0446 182.94C30.1017 180.011 53.2814 188.371 54.5536 196.849",
    stroke: "url(#paint16_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8096 220.503C22.0954 222.943 19.6436 216.961 18.5834 209.897C17.5233 202.832 17.0067 189.032 23.7209 186.591C30.4351 184.151 49.7516 191.118 50.8117 198.183",
    stroke: "url(#paint17_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4673 217.372C24.0959 219.325 22.1344 214.539 21.2863 208.887C20.4381 203.235 20.0249 192.196 25.3963 190.243C30.7676 188.291 46.2208 193.864 47.0689 199.516",
    stroke: "url(#paint18_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1249 214.242C26.0963 215.706 24.6252 212.117 23.9891 207.878C23.353 203.639 23.0431 195.359 27.0716 193.895C31.1001 192.431 42.69 196.611 43.3261 200.85",
    stroke: "url(#paint19_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7825 211.111C28.0968 212.087 27.116 209.695 26.692 206.869C26.2679 204.043 26.0613 198.523 28.747 197.547C31.4327 196.571 39.1592 199.357 39.5833 202.183",
    stroke: "url(#paint20_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4401 207.981C30.0972 208.469 29.6068 207.273 29.3948 205.86C29.1828 204.447 29.0795 201.687 30.4223 201.199C31.7652 200.71 35.6284 202.104 35.8405 203.517",
    stroke: "url(#paint21_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.628 107.722C578.086 118.46 567.298 92.1401 562.633 61.0547C557.968 29.9693 555.695 -30.7503 585.238 -41.4879C614.781 -52.2255 699.773 -21.5713 704.438 9.51416",
    stroke: "url(#paint22_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.286 104.591C580.086 114.841 569.789 89.7177 565.336 60.0453C560.883 30.3728 558.714 -27.5868 586.913 -37.8363C615.113 -48.0859 696.242 -18.825 700.695 10.8475",
    stroke: "url(#paint23_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.944 101.461C582.087 111.222 572.279 87.2956 568.039 59.0361C563.798 30.7766 561.732 -24.423 588.589 -34.1845C615.446 -43.946 692.711 -16.0784 696.952 12.181",
    stroke: "url(#paint24_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.601 98.3306C584.087 107.604 574.77 84.8734 570.742 58.0269C566.713 31.1804 564.75 -21.2593 590.264 -30.5326C615.778 -39.806 689.181 -13.3319 693.209 13.5146",
    stroke: "url(#paint25_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.259 95.1999C586.088 103.985 577.261 82.451 573.444 57.0175C569.628 31.5839 567.768 -18.0957 591.939 -26.8811C616.111 -35.6664 685.65 -10.5856 689.466 14.8479",
    stroke: "url(#paint26_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.916 92.0695C588.088 100.367 579.752 80.0288 576.147 56.0083C572.543 31.9877 570.786 -14.932 593.615 -23.2292C616.443 -31.5265 682.119 -7.83907 685.724 16.1815",
    stroke: "url(#paint27_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.575 88.9388C590.09 96.748 582.244 77.6064 578.851 54.9988C575.459 32.3913 573.806 -11.7684 595.291 -19.5776C616.777 -27.3868 678.589 -5.09278 681.982 17.5148",
    stroke: "url(#paint28_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.233 85.8084C592.09 93.1295 584.734 75.1843 581.554 53.9897C578.373 32.795 576.824 -8.60468 596.966 -15.9258C617.109 -23.2469 675.058 -2.34624 678.239 18.8484",
    stroke: "url(#paint29_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.89 82.6777C594.09 89.5107 587.225 72.7618 584.257 52.9802C581.288 33.1986 579.842 -5.44116 598.642 -12.2742C617.442 -19.1072 671.528 0.400045 674.496 20.1817",
    stroke: "url(#paint30_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.548 79.5472C596.091 85.8922 589.716 70.3397 586.96 51.971C584.203 33.6024 582.86 -2.27739 600.317 -8.62235C617.774 -14.9673 667.997 3.14659 670.753 21.5152",
    stroke: "url(#paint31_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.205 76.4165C598.091 82.2734 592.207 67.9173 589.662 50.9616C587.118 34.0059 585.878 0.886131 601.992 -4.97075C618.107 -10.8276 664.466 5.89287 667.01 22.8486",
    stroke: "url(#paint32_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.863 73.2861C600.092 78.6549 594.698 65.4951 592.365 49.9524C590.033 34.4097 588.897 4.0499 603.668 -1.31891C618.439 -6.68772 660.935 8.63941 663.268 24.1821",
    stroke: "url(#paint33_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.521 70.1557C602.092 75.0364 597.188 63.073 595.068 48.9432C592.948 34.8135 591.915 7.21366 605.343 2.33293C618.772 -2.54781 657.405 11.386 659.525 25.5157",
    stroke: "url(#paint34_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.178 67.025C604.093 71.4177 599.679 60.6505 597.771 47.9338C595.863 35.217 594.933 10.3772 607.019 5.98452C619.104 1.59186 653.874 14.1322 655.782 26.849",
    stroke: "url(#paint35_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.836 63.8943C606.093 67.7989 602.17 58.2281 600.474 46.9244C598.778 35.6206 597.951 13.5407 608.694 9.63612C619.437 5.73153 650.343 16.8785 652.039 28.1823",
    stroke: "url(#paint36_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.493 60.7639C608.094 64.1804 604.661 55.806 603.177 45.9152C601.693 36.0243 600.969 16.7045 610.369 13.288C619.769 9.87144 646.812 19.6251 648.296 29.5159",
    stroke: "url(#paint37_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.151 57.6332C610.094 60.5616 607.152 53.3836 605.88 44.9057C604.607 36.4279 603.988 19.868 612.045 16.9396C620.102 14.0111 643.281 22.3714 644.554 30.8492",
    stroke: "url(#paint38_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.81 54.5028C612.095 56.9431 609.644 50.9614 608.583 43.8965C607.523 36.8317 607.007 23.0318 613.721 20.5914C620.435 18.151 639.752 25.1179 640.812 32.1828",
    stroke: "url(#paint39_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.467 51.3723C614.096 53.3246 612.134 48.5392 611.286 42.8873C610.438 37.2354 610.025 26.1955 615.396 24.2432C620.768 22.2909 636.221 27.8644 637.069 33.5163",
    stroke: "url(#paint40_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.125 48.2416C616.096 49.7059 614.625 46.1168 613.989 41.8779C613.353 37.639 613.043 29.359 617.072 27.8948C621.1 26.4306 632.69 30.6107 633.326 34.8497",
    stroke: "url(#paint41_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.782 45.1112C618.097 46.0874 617.116 43.6947 616.692 40.8687C616.268 38.0428 616.061 32.5228 618.747 31.5467C621.433 30.5705 629.159 33.3573 629.583 36.1832",
    stroke: "url(#paint42_linear_2832_25885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.44 41.9808C620.097 42.4688 619.607 41.2725 619.395 39.8595C619.183 38.4466 619.079 35.6866 620.422 35.1985C621.765 34.7104 625.628 36.1038 625.84 37.5168",
    stroke: "url(#paint43_linear_2832_25885)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2832_25885",
    x1: 6780.45,
    y1: 2342.81,
    x2: 1945.07,
    y2: 17045.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2832_25885",
    x1: 6473.71,
    y1: 2245.63,
    x2: 1858.12,
    y2: 16279.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2832_25885",
    x1: 6166.96,
    y1: 2148.45,
    x2: 1771.17,
    y2: 15514.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2832_25885",
    x1: 5860.22,
    y1: 2051.27,
    x2: 1684.21,
    y2: 14748.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2832_25885",
    x1: 5553.48,
    y1: 1954.09,
    x2: 1597.26,
    y2: 13983.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2832_25885",
    x1: 5246.74,
    y1: 1856.91,
    x2: 1510.31,
    y2: 13217.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2832_25885",
    x1: 4939.99,
    y1: 1759.73,
    x2: 1423.35,
    y2: 12452.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2832_25885",
    x1: 4633.25,
    y1: 1662.55,
    x2: 1336.4,
    y2: 11686.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2832_25885",
    x1: 4326.51,
    y1: 1565.37,
    x2: 1249.45,
    y2: 10921.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2832_25885",
    x1: 4019.76,
    y1: 1468.19,
    x2: 1162.49,
    y2: 10156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2832_25885",
    x1: 3713.02,
    y1: 1371.01,
    x2: 1075.54,
    y2: 9390.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2832_25885",
    x1: 3406.27,
    y1: 1273.83,
    x2: 988.585,
    y2: 8625.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2832_25885",
    x1: 3099.53,
    y1: 1176.65,
    x2: 901.632,
    y2: 7859.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2832_25885",
    x1: 2792.79,
    y1: 1079.47,
    x2: 814.679,
    y2: 7094.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2832_25885",
    x1: 2486.04,
    y1: 982.29,
    x2: 727.725,
    y2: 6328.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2832_25885",
    x1: 2179.3,
    y1: 885.11,
    x2: 640.772,
    y2: 5563.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2832_25885",
    x1: 1872.56,
    y1: 787.93,
    x2: 553.818,
    y2: 4797.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2832_25885",
    x1: 1565.81,
    y1: 690.75,
    x2: 466.865,
    y2: 4032.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2832_25885",
    x1: 1259.07,
    y1: 593.57,
    x2: 379.912,
    y2: 3266.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2832_25885",
    x1: 952.328,
    y1: 496.39,
    x2: 292.958,
    y2: 2501.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2832_25885",
    x1: 645.585,
    y1: 399.21,
    x2: 206.005,
    y2: 1735.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2832_25885",
    x1: 338.841,
    y1: 302.03,
    x2: 119.051,
    y2: 970.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2832_25885",
    x1: 7370.45,
    y1: 2176.81,
    x2: 2535.07,
    y2: 16879.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2832_25885",
    x1: 7063.71,
    y1: 2079.63,
    x2: 2448.12,
    y2: 16113.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2832_25885",
    x1: 6756.96,
    y1: 1982.45,
    x2: 2361.17,
    y2: 15348.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2832_25885",
    x1: 6450.22,
    y1: 1885.27,
    x2: 2274.21,
    y2: 14582.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2832_25885",
    x1: 6143.48,
    y1: 1788.09,
    x2: 2187.26,
    y2: 13817.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2832_25885",
    x1: 5836.74,
    y1: 1690.91,
    x2: 2100.31,
    y2: 13051.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2832_25885",
    x1: 5529.99,
    y1: 1593.73,
    x2: 2013.35,
    y2: 12286.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2832_25885",
    x1: 5223.25,
    y1: 1496.55,
    x2: 1926.4,
    y2: 11520.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2832_25885",
    x1: 4916.51,
    y1: 1399.37,
    x2: 1839.45,
    y2: 10755.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2832_25885",
    x1: 4609.76,
    y1: 1302.19,
    x2: 1752.49,
    y2: 9989.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2832_25885",
    x1: 4303.02,
    y1: 1205.01,
    x2: 1665.54,
    y2: 9224.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2832_25885",
    x1: 3996.27,
    y1: 1107.83,
    x2: 1578.59,
    y2: 8459.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2832_25885",
    x1: 3689.53,
    y1: 1010.65,
    x2: 1491.63,
    y2: 7693.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2832_25885",
    x1: 3382.79,
    y1: 913.47,
    x2: 1404.68,
    y2: 6928.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2832_25885",
    x1: 3076.04,
    y1: 816.29,
    x2: 1317.73,
    y2: 6162.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2832_25885",
    x1: 2769.3,
    y1: 719.11,
    x2: 1230.77,
    y2: 5397.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2832_25885",
    x1: 2462.56,
    y1: 621.93,
    x2: 1143.82,
    y2: 4631.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2832_25885",
    x1: 2155.81,
    y1: 524.75,
    x2: 1056.87,
    y2: 3866.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2832_25885",
    x1: 1849.07,
    y1: 427.57,
    x2: 969.912,
    y2: 3100.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2832_25885",
    x1: 1542.33,
    y1: 330.39,
    x2: 882.958,
    y2: 2335.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2832_25885",
    x1: 1235.58,
    y1: 233.21,
    x2: 796.005,
    y2: 1569.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2832_25885",
    x1: 928.841,
    y1: 136.03,
    x2: 709.051,
    y2: 804.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#53A5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2832_25885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1032,
    height: 245,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBg);
export default __webpack_public_path__ + "static/media/Dashboard_bg.b9e1ea0c15abd3b2069d5e357886a9af.svg";
export { ForwardRef as ReactComponent };